import React from 'react';

interface FsCheckboxLargeSelectedIconProps {
  color?: string;
}

const FsCheckboxLargeSelectedIcon: React.FC<FsCheckboxLargeSelectedIconProps> = ({
  color = 'white',
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="25" height="25" rx="3.5" stroke={color} />
      <path
        d="M5 13.6064L10.0711 18.6775L20.6777 8.07091"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default FsCheckboxLargeSelectedIcon;
